import React from 'react';
import { useTranslation } from 'react-i18next';

import { useCreateLookbookWishlist } from '../../../services/hooks/lookbook/useCreateLookbookWishlist';
import { Modal } from '../../various/Modal';
import { useLookbookContext } from '../context/LookbookContext';
import { useLookbookWishlistContext } from '../context/LookbookWishlistContext';

import { WishlistShareForm } from './WishlistShareForm';

interface Props {
  isOpen: boolean;
  onClose: VoidFunction;
}

export const WishlistShareModal = ({ onClose, isOpen }: Props) => {
  const { t } = useTranslation(['lookbook']);
  const { lookbookId } = useLookbookContext();
  const { wishlist } = useLookbookWishlistContext();
  const { isPending: isWishlistPending, mutate: createWishlist, reset, isError, data } = useCreateLookbookWishlist();

  React.useEffect(() => {
    if (isOpen) {
      createWishlist({
        data: {
          products: [...wishlist],
        },
        lookbookId,
      });
    } else {
      reset();
    }
  }, [isOpen, wishlist, lookbookId, createWishlist, reset]);

  return (
    <Modal isOpen={isOpen} title={t('lookbook:share_wishlist')} onClose={onClose} size="medium">
      <WishlistShareForm isError={isError} isPending={isWishlistPending} wishlistId={data?.wishlist} lookbookId={lookbookId} />
    </Modal>
  );
};
